/* eslint-disable no-bitwise */
import SparkMD5 from "spark-md5";
import { bytesToHex, hexToBytes } from "../hex";
function hash(input) {
    return hexToBytes(SparkMD5.hash(input, false));
}
function xor(hashA, hashB) {
    const len = Math.max(hashA.length, hashB.length);
    const res = new Uint8Array(len);
    for (let index = 0; index < len; index++) {
        res[index] = (hashA[index] ?? 0) ^ (hashB[index] ?? 0);
    }
    return res;
}
function update(previousHash, nextInput) {
    return xor(previousHash, hash(nextInput));
}
// Public contract:
export function orderIndependentHash(entriesToHash) {
    let result = undefined;
    for (const entry of entriesToHash) {
        if (!result) {
            result = hash(entry);
        }
        else {
            result = update(result, entry);
        }
    }
    return result ? bytesToHex(result) : undefined;
}
//# sourceMappingURL=orderIndependentHash.js.map